import React from 'react';
import { Tooltip } from 'antd';
import { get } from 'lodash';
import { UsPgaFlag } from '__generated__/graphql';
import type { NamePath } from '@xbcb/ui-types';
import { getCodes, getEnv } from '@xbcb/ui-utils';
import LineItemPgaTab from 'components/LineItemPgaTab';
import { isCpscFeatureEnabled } from 'featureFlags';
import type { CommercialInvoiceBaseProps, TabElement, Tariff } from 'types';
export interface GetLineItemPgaTabsProps extends CommercialInvoiceBaseProps {
  getTabTitle: (
    baseTitle: string,
    namePathsToValidate?: NamePath[],
  ) => React.ReactElement | string;
  shipperId?: string;
  createdTime?: string;
  tariffs?: Tariff[];
}

export const getLineItemPgaTabs = (
  allPGAFlags: UsPgaFlag[][] = [],
  {
    fullNamePath,
    localNamePath,
    disabled,
    readOnly,
    required,
    getTabTitle,
    shipperId,
    createdTime,
    tariffs = [],
  }: GetLineItemPgaTabsProps,
): TabElement[][] => {
  const { stage } = getEnv();
  const codes = getCodes();
  const agencyCodes = codes.CBP.CATAIR.PGA.agency;
  const pgaFlags = codes.CBP.CATAIR.PGA.flag;

  const cpscFeatureEnabled = isCpscFeatureEnabled({
    stage,
    time: createdTime,
    shipper: shipperId,
  });

  return allPGAFlags.map((flags, index) => {
    const tariff = tariffs[index];
    const tariffHasCp1Data =
      tariff &&
      'pga' in tariff &&
      (tariff as { pga?: { CP1?: unknown } }).pga?.CP1 != null;

    return flags
      .filter(
        (pgaFlag) =>
          Object.values(UsPgaFlag).includes(pgaFlag) &&
          (cpscFeatureEnabled || pgaFlag !== UsPgaFlag.CP1 || tariffHasCp1Data),
      )
      .map((pgaFlag) => ({
        key: pgaFlag,
        label: (
          <Tooltip
            title={get(agencyCodes, [
              get(pgaFlags, [pgaFlag, 'agencyCode']),
              'name',
            ])}
          >
            {getTabTitle(get(pgaFlags, [pgaFlag, 'agencyCode']), [
              [...fullNamePath, 'tariffs', index, 'pga', pgaFlag],
            ])}
          </Tooltip>
        ),
        forceRender: true,
        children: (
          <LineItemPgaTab
            pgaFlag={pgaFlag}
            formDisabled={disabled}
            readOnly={readOnly}
            required={required}
            fullNamePath={[...fullNamePath, 'tariffs', index, 'pga', pgaFlag]}
            localNamePath={[...localNamePath, 'tariffs', index, 'pga', pgaFlag]}
          />
        ),
      }));
  });
};
